module.exports = __webpack_public_path__ + "static/test-et-reussite-permis-8b91e16a12a95b0a4cf048a3c49ed046.png";